import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { FormTypeEnum } from '@/types';

import { useBatchLogos } from '../api/batch-logos';
import { useDeleteLogos } from '../api/delete-logos';
import { TLogo } from '../types';

type TLogosControllersReturn = {
  logosDialog: ReturnType<typeof useDisclosureWithData<TLogo>>;
  logosDrawer: ReturnType<typeof useDisclosureWithData<{ type: FormTypeEnum; data: TLogo }>>;
  handleDeleteLogos: () => void;
  multiLogosDialog: ReturnType<typeof useDisclosureWithData<TLogo[]>>;
  handleDeleteMultipleLogos: () => void;
};

export function useLogosControllers(): TLogosControllersReturn {
  const logosDialog = useDisclosureWithData<TLogo>();
  const logosDrawer = useDisclosureWithData<{ type: FormTypeEnum; data: TLogo }>();
  const { mutate: deleteLogos } = useDeleteLogos();

  const multiLogosDialog = useDisclosureWithData<TLogo[]>();

  const { mutate: deleteMultipleLogos } = useBatchLogos();

  const handleDeleteLogos = () => {
    if (logosDialog.data) {
      deleteLogos(
        {
          id: logosDialog.data.id,
        },
        {
          onSuccess: () => {
            logosDialog.close();
          },
        }
      );
    }
  };

  const handleDeleteMultipleLogos = () => {
    if (multiLogosDialog.data) {
      deleteMultipleLogos(
        {
          action: 'delete',
          items: multiLogosDialog.data.map(logo => ({ id: logo.id })),
        },
        {
          onSuccess: () => {
            multiLogosDialog.close();
          },
        }
      );
    }
  };

  return {
    logosDialog,
    logosDrawer,
    multiLogosDialog,
    handleDeleteLogos,
    handleDeleteMultipleLogos,
  };
}
